module.exports = __webpack_public_path__ + "media/flags/am-1ca356bb.svg";